import React from "react";
import { Link } from "react-router-dom";
import Seamless from "./Seamless";
import Lsaw from "./Lsaw";
import Stainless from "./Stainless";
import Ssaw from "./Ssaw";


const StructuralFramework = () => {

  return (
    <div className="flex flex-col md:flex-row bg-[#0c2341] text-white">
      <main className="">
        <h1 className="text-base md:text-2xl md:mb-3 py-2">
          <Link to="/">Home</Link> / AKT STEEL DIVISION /{" "}
          <span className="font-bold">AKT STEEL</span>
        </h1>
        <h1 className="text-2xl md:text-4xl font-bold">
        SEAMLESS PIPE
        </h1>
        <div className="">
          <Seamless />
        </div>
        <h1 className="text-2xl md:text-4xl font-bold">
        LSAW PIPE
        </h1>
        <div className="">
          <Lsaw />
        </div>
        <h1 className="text-2xl md:text-4xl font-bold">
        STAINLESS PIPE
        </h1>
        <div className="">
          <Stainless />
        </div>
        <h1 className="text-2xl md:text-4xl font-bold">
        SSAW PIPES
        </h1>
        <div className="">
          <Ssaw />
        </div>
      </main>
    </div>
  );
};

export default StructuralFramework;
